/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { OrderForm } from "./OrderForm";

export const OrderColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { moduleValues, setModuleValues }
) => (
  <OrderForm
    id={row.id}
    moduleValues={moduleValues}
    setModuleValues={setModuleValues}
  />
)